import compose from 'lodash/fp/compose';

import { withDocumentTitle } from '../generic/DocumentTitle';
import withResolved from '../REST/with-resolved';
import ShowContact from './ShowContact';
import { getTransformedContact } from './transform-contact-helpers';
import { fullName } from './utils';

export default compose(
  withResolved({
    query: getTransformedContact,
    deriveQueryArgs: props => ({ id: props.match.params.id }),
    as: 'model',
  }),
  withDocumentTitle(({ model }) => fullName(model)),
)(ShowContact);
